import React from 'react';
import { HeadFC, graphql } from 'gatsby';
import SEO from '../../components/Head';
import WidgetV2 from '../../components/WidgetV2';
import Layout from '../../components/Layout';

interface ContextType {
  locale: string;
  name: string;
}

const Provider = () => {
  return (
    <Layout>
      <WidgetV2 isProviderPage />
    </Layout>
  );
};

export const Head: HeadFC<Queries.HomePageQuery, ContextType> = ({
  data: { file },
  pageContext,
  location,
}) => {
  return (
    <>
      <SEO
        meta={file?.childJson?.meta || null}
        pathname={location.pathname}
        locale={pageContext.locale}
      />
      <meta name="robots" content="noindex, nofollow" />
    </>
  );
};

export const query = graphql`
  query ProviderPage {
    file(name: { eq: "content.en" }, relativePath: { glob: "**/home/**" }) {
      childJson {
        ...Meta
      }
    }
  }
`;

export default Provider;
